export enum Currency {
  PLN = 'PLN',
}

export interface SelectOption {
  label: string;
  value: string;
  role?: string;
}

export interface UserVerified {
  verified: boolean;
  message: string;
  description: string;
  action: () => void;
  routeName: string;
}

export enum OfferSigningStatus {
  PROJECT = 'Projekt Oferty',
  OFFER_CERTIFICATE = 'Certyfikat Oferty',
  LEASE_OFFER_CERTIFICATE = 'Certyfikat Umowy Najmu',
}

export interface User {
  email: string;
  firstName: string;
  lastName: string;
  marketingConsent: boolean;
  uid: string;
  favorites: string[];
  isRealEstateAgent?: boolean;
  professionalLicenseNumber?: string;
}

export interface AgencyAgreement {
  id: string;
  agentUid: string;
  offerId: string;
  ownerDetails: {
    name: string;
    address: string;
    peselOrNip: string;
    contact: string;
    email: string;
  };
  status: 'pending' | 'signed' | 'rejected';
  agentSignedAt: Date;
  ownerSignedAt?: Date;
  agreementUrl?: string;
  createdAt: Date;
}
